/** Location statuses, allowance based on subscription type */
export const LOCATION_STATUS = {
  ACTIVE: 'active',
  ADHOC: 'adhoc',
  MANAGED: 'managed'
} as const;

/**
 * Legacy location statuses the Capabilities API can still return. New Platform has no UI for them.
 * TODO: https://brightlocal.atlassian.net/browse/CE-4289
 */
export const LEGACY_LOCATION_STATUS = {
  PARKED: 'parked',
  ARCHIVED: 'archived',
  LEAD: 'lead'
} as const;
